import React from "react";
import styles from "./label-plus-drop-down-with-black-background.module.scss";
import { DropDownBlackBackground } from "@components/atoms/dropdown-black-background/dropdown-black-background";

const cssClassName = "label-plus-drop-down-with-black-background";

interface LabelPlusDropDownWithBlackBackgroundPropTypes {
  dropDownId: string;
  labelText: string;
  dropDownValue: string;
  dropDownValuesAndLabels: { [key: string]: string };
  callback: (value: string) => void;
}

export const LabelPlusDropDownWithBlackBackground = ({
  dropDownId,
  labelText,
  dropDownValue,
  dropDownValuesAndLabels,
  callback,
}: LabelPlusDropDownWithBlackBackgroundPropTypes) => {
  return (
    <div>
      <div className={styles[`${cssClassName}__extra-margin-bottom`]}>
        <div className={styles[`${cssClassName}__attribute-name`]}>
          {labelText}
        </div>
      </div>
      <DropDownBlackBackground
        id={dropDownId}
        dropDownValue={dropDownValue}
        dropDownValuesAndLabels={dropDownValuesAndLabels}
        callback={callback}
      />
    </div>
  );
};
